import React, { useEffect, useRef, useState } from 'react';
import { navigate } from 'raviger';
import '../shared/SidenavNew.css';
import * as auth from "../../backend/auth";
import { preventDefault } from '../../utils/common';
import Icon from '../common/Icon';
import { getBasePath } from '../../App';
import { USER_PRIVILEGES } from '../pages/UserManagement/Roles/RoleConfiguration';
import mofoi_logo from '../../assets/img/MOFOI_LOGO.png'


const SideNavMenu = [
    // { id: 'dashboard', url: '/dashboard', icon: 'th', label: 'Dashboard', privilege: USER_PRIVILEGES.SUBMITTER_DASHBOARD },
    {
        id: 'vendor-audit-dashboard',
        url: '/vendor-audit-dashboard',
        icon: 'vendor-audit-dashboard',
        label: 'Vendor Audit Dashboard',
        privilege: USER_PRIVILEGES.VENDOR_AUDIT_DASHBOARD
    },
    {
        id: "vendor-audits",
        url: "/vendor-audits",
        icon: "notes",
        label: "Vendor Audits",
        privilege: USER_PRIVILEGES.REVIEWER_VENDOR_ACTIVITIES,
    },
    {
        id: 'location-audit-dashboard',
        url: '/location-audit-dashboard',
        icon: 'location-audit-dashboard',
        label: 'Location Audit Dashboard',
        privilege: USER_PRIVILEGES.LOCATION_AUDIT_DASHBOARD 
    },
    {
        id: "vendor-audits",
        url: "/vendor-audits",
        // icon: "task",
        icon: "notes",
        label: "Vendor Audits",
        privilege: USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES,
    },
    // { id: 'dashboard', url: '/dashboard', icon: 'th', label: 'Dashboard', privilege: USER_PRIVILEGES.REVIEWER_DASHBOARD },
    { id: 'dashboard', url: '/dashboard', icon: 'th', label: 'Dashboard', privilege: USER_PRIVILEGES.OWNER_DASHBOARD },
    { id: 'dashboard', url: '/dashboard', icon: 'th', label: 'Dashboard', privilege: USER_PRIVILEGES.MANAGER_DASHBOARD },
    { id: 'dashboard', url: '/dashboard', icon: 'th', label: 'Dashboard', privilege: USER_PRIVILEGES.ESCALATION_DASHBOARD },

    {
        id: 'masters', url: '/masters/act', icon: 'crown', label: 'Masters',
        children: [
            { id: 'masters/law', url: '/masters/law', label: 'Law Category', privilege: USER_PRIVILEGES.VIEW_LAW },
            {
                id: "masters/vendor-categories",
                url: "/masters/vendor-categories",
                label: "Vendor Category",
                privilege: USER_PRIVILEGES.VIEW_VENDOR_CATEGORY,
            },
            { id: 'masters/Act', url: '/masters/Act', label: 'Act', privilege: USER_PRIVILEGES.VIEW_ACT },
            { id: 'masters/activity', url: '/masters/activity', label: 'Activity', privilege: USER_PRIVILEGES.VIEW_ACTIVITY },
            { id: 'masters/rule', url: '/masters/rule', label: 'Rule', privilege: USER_PRIVILEGES.VIEW_RULE },
            { id: 'masters/state', url: '/masters/state', label: 'State', privilege: USER_PRIVILEGES.VIEW_STATE },
            { id: 'masters/city', url: '/masters/city', label: 'City', privilege: USER_PRIVILEGES.VIEW_CITY },
            // { id: 'masters/compliance', url: '/masters/compliance', label: 'Rule Compliance', privilege: USER_PRIVILEGES.VIEW_RULE_COMPLIANCE },
            { id: 'masters/mapping', url: '/masters/mapping', label: 'Mappings', privilege: USER_PRIVILEGES.VIEW_MAPPINGS },
            { id: 'setupInput/stateRegisterConfiguration', url: '/setupInput/stateRegisterConfiguration', label: 'State Register Configuration', privilege: USER_PRIVILEGES.VIEW_STATEREGISTER_CONFIGURATION }
        ]
    },
    {
        id: 'companies', url: '/companies/list', icon: 'building', label: 'Companies',
        children: [
            {
                id: 'companies/list', url: '/companies/list',
                label: 'Manage Companies', privilege: USER_PRIVILEGES.VIEW_COMPANIES
            },
            {
                id: 'companies/associateCompanies', url: '/companies/associateCompanies',
                label: 'Associate Companies', privilege: USER_PRIVILEGES.VIEW_ASSOCIATE_COMPANIES
            },
            {
                id: 'companies/locationMapping', url: '/companies/locationMapping',
                label: 'Location Mapping', privilege: USER_PRIVILEGES.VIEW_LOCATION_MAPPINGS
            },
            {
                id: "companies/vendor-location-mapping",
                url: "/companies/vendor-location-mapping",
                label: "Vendor Mapping",
                privilege: USER_PRIVILEGES.VIEW_VENDOR_LOCATION_MAPPING,
            },
            {
                id: "companies/manageVendors",
                url: "/companies/manageVendors",
                label: "Manage Vendors",
                privilege: USER_PRIVILEGES.VIEW_VENDORS,
            },
            {
                id: 'companies/verticals', url: '/companies/verticals',
                label: 'Verticals', privilege: USER_PRIVILEGES.VIEW_VERTICAL
            },
            {
                id: 'companies/departments', url: '/companies/departments',
                label: 'Departments', privilege: USER_PRIVILEGES.VIEW_DEPARTMENT
            },
            {
                id: 'companies/escalationMatrix', url: '/companies/escalationMatrix',
                label: 'Escalation Matrix', privilege: USER_PRIVILEGES.VIEW_COMPANY_ESCALTION_MATIX
            }
        ]
    },
    {
        id: "licenses",
        url: "/license-management/licenses",
        label: "Licenses",
        icon: "dashboardNew",
        privilege: USER_PRIVILEGES.VIEW_LICENSE_DASHBOARD,
    },
    {
        id: "license-applications",
        url: "/license-management/license-applications",
        label: "License Applications",
        icon: "LicenseApplication",
        privilege: USER_PRIVILEGES.VIEW_LICENSE_APPLICATIONS,
    },
    {
        id: "license-types",
        url: "/license-management/license-types",
        label: "License Types",
        icon: "LicenseType",
        privilege: USER_PRIVILEGES.VIEW_LICENSE_TYPES,
    },
    {
        id: "notices",
        url: "/notice-management/notices",
        label: "Notices",
        icon: "LicenseApplication",
        privilege: USER_PRIVILEGES.NOTICE_MANAGER,
    },
    {
        id: "notices",
        url: "/notice-management/notices",
        label: "Notices",
        icon: "LicenseApplication",
        privilege: USER_PRIVILEGES.NOTICE_OWNER,
    },
    {
        id: "notices",
        url: "/notice-management/notices",
        label: "Notices",
        icon: "LicenseApplication",
        privilege: USER_PRIVILEGES.NOTICE_WATCHER,
    },
    {
        id: "litigations",
        url: "/notice-management/litigations",
        label: "Litigations",
        icon: "litigationnavicon",
        privilege: USER_PRIVILEGES.NOTICE_MANAGER,
    },
    {
        id: "litigations",
        url: "/notice-management/litigations",
        label: "Litigations",
        icon: "litigationnavicon",
        privilege: USER_PRIVILEGES.NOTICE_OWNER,
    },
    {
        id: "litigations",
        url: "/notice-management/litigations",
        label: "Litigations",
        icon: "litigationnavicon",
        privilege: USER_PRIVILEGES.NOTICE_WATCHER,
    },
    {
        id: 'auditSchedule', url: '/auditSchedule/importExport', icon: 'notes', label: 'Location Audit Management',
        children: [
            {
                id: 'auditSchedule/importExport', url: '/auditSchedule/importExport',
                label: 'Audit Schedule', privilege: USER_PRIVILEGES.AUDIT_SCHEDULE
            },
            {
                id: 'auditSchedule/details', url: '/auditSchedule/details',
                label: 'Audit Schedule Details', privilege: USER_PRIVILEGES.VIEW_AUDIT_SCHEDULE_DETAILS
            },
            {
                id: 'auditSchedule/blockUnblock', url: '/auditSchedule/blockUnblock',
                label: 'Un-Block Activities', privilege: USER_PRIVILEGES.VIEW_AUDIT_SCHEDULE_BLOCK_UNBLOCK
            }
        ]
    },
    {
        id: "vendor-audit-schedule",
        url: "/vendor-audit-schedule/import-export",
        icon: "notes",
        label: "Vendor Audit Management",
        children: [
            {
                id: "vendor-audit-schedule/import-export",
                url: "/vendor-audit-schedule/import-export",
                label: "Audit Schedule",
                privilege: USER_PRIVILEGES.AUDIT_VENDOR_SCHEDULE,
            },
            {
                id: "vendor-audit-schedule/details",
                url: "/vendor-audit-schedule/details",
                label: "Audit Schedule Details",
                privilege: USER_PRIVILEGES.VIEW_AUDIT_VENDOR_SCHEDULE_DETAILS,
            },
            {
                id: "vendor-audit-schedule/block-unblock",
                url: "/vendor-audit-schedule/block-unblock",
                label: "Un-Block Activities",
                privilege: USER_PRIVILEGES.VIEW_AUDIT_VENDOR_SCHEDULE_BLOCK_UNBLOCK,
            },
        ],
    },
    {
        id: 'complianceManagement', url: '/complianceManagement/list', icon: 'notepad', label: 'Compliance Management', children: [
            {
                id: 'complianceManagement/complianceSchedule', url: '/complianceManagement/complianceSchedule',
                label: 'Compliance Schedule', privilege: USER_PRIVILEGES.COMPLIANCE_SCHEDULE
            },
            {
                id: 'complianceManagement/compliance-schedule-details', url: '/complianceManagement/compliance-schedule-details',
                label: 'Comp Schedule Details', privilege: USER_PRIVILEGES.VIEW_COMPLIANCE_SCHEDULE_DETAILS
            }
            // {
            //     id: 'complianceManagement/blockUnblock', url: '/complianceManagement/blockUnblock',
            //     label: 'Block Un-Block', privilege: USER_PRIVILEGES.VIEW_AUDIT_SCHEDULE_BLOCK_UNBLOCK
            // }
        ]
    },
    {
        id: 'setupInput', url: '/setupInput', icon: 'setupInput', label: 'Setup Input',
        children: [
            { id: 'setupInput/holidayList', url: '/setupInput/holidayList', label: 'Holiday List', privilege: USER_PRIVILEGES.VIEW_HOLIDAY_LIST },
            { id: 'setupInput/leaveConfiguration', url: '/setupInput/leaveConfiguration', label: 'Leave Configuration', privilege: USER_PRIVILEGES.VIEW_LEAVE_CONFIGURATION },
            { id: 'setupInput/attendanceConfig', url: '/setupInput/attendanceConfig', label: 'Attendance Config', privilege: USER_PRIVILEGES.VIEW_ATTENDANCE_CONFIGURATION },
            { id: 'setupInput/salaryComponents', url: '/setupInput/salaryComponents', label: 'Salary Components', privilege: USER_PRIVILEGES.VIEW_SALARY_COMPONENTS },
            { id: 'setupInput/inputModuleUploads', url: '/setupInput/inputModuleUploads', label: 'Input Module Uploads', privilege: USER_PRIVILEGES.VIEW_INPUT_MODULE_UPLOAD },
            // { id: 'setupInput/holidayList', url: '/setupInput/holidayList', label: 'Holiday List', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'setupInput/leaveConfiguration', url: '/setupInput/leaveConfiguration', label: 'Leave Configuration', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'setupInput/attendanceConfig', url: '/setupInput/attendanceConfig', label: 'Attendance Config', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'setupInput/salaryComponents', url: '/setupInput/salaryComponents', label: 'Salary Components', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'setupInput/inputModuleUploads', url: '/setupInput/inputModuleUploads', label: 'Input Module Uploads', privilege: USER_PRIVILEGES.VIEW_LAW },
        ]
    },
    {
        id: 'inputUploads', url: '/inputUploads', icon: 'LicenseType', label: 'Input Uploads',
        children: [

            { id: 'inputUploads/dashboard', url: '/inputUploads/dashboard', label: 'Dashboard', privilege: USER_PRIVILEGES.VIEW_EMPLOYEE_DASHBOARD },
            //{ id: 'inputUploads/registerDownload', url: '/inputUploads/registerDownload', label: 'Register Download', privilege: USER_PRIVILEGES.VIEW_REGISTER_DOWNLOAD },
            { id: 'inputUploads/RegistersQue', url: '/inputUploads/RegistersQue', label: 'RegistersQue ', privilege: USER_PRIVILEGES.VIEW_REGISTER_QUE },

            { id: 'inputUploads/employeeMasterUpload', url: '/inputUploads/employeeMasterUpload', label: 'Employee Master', privilege: USER_PRIVILEGES.VIEW_EMPLOYEE_MASTER },
            { id: 'inputUploads/employeeLeaveCreditUpload', url: '/inputUploads/employeeLeaveCreditUpload', label: 'Employee Leave Credit', privilege: USER_PRIVILEGES.VIEW_EMPLOYEE_LEAVE_CREDIT },
            { id: 'inputUploads/employeeLeaveAvailedUpload', url: '/inputUploads/employeeLeaveAvailedUpload', label: 'Employee Leave Availed', privilege: USER_PRIVILEGES.VIEW_EMPLOYEE_LEAVE_AVAILED },
            { id: 'inputUploads/employeeAttendanceUpload', url: '/inputUploads/employeeAttendanceUpload', label: 'Employee Attendance', privilege: USER_PRIVILEGES.VIEW_EMPLOYEE_ATTENDANCE },
            { id: 'inputUploads/employeeWageUpload', url: '/inputUploads/employeeWageUpload', label: 'Employee Wage', privilege: USER_PRIVILEGES.VIEW_EMPLOYEE_WAGE }

            // { id: 'inputUploads/dashboard', url: '/inputUploads/dashboard', label: 'Dashboard', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'inputUploads/registerDownload', url: '/inputUploads/registerDownload', label: 'Register Download', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'inputUploads/employeeMasterUpload', url: '/inputUploads/employeeMasterUpload', label: 'Employee Master', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'inputUploads/employeeLeaveCreditUpload', url: '/inputUploads/employeeLeaveCreditUpload', label: 'Employee Leave Credit', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'inputUploads/employeeLeaveAvailedUpload', url: '/inputUploads/employeeLeaveAvailedUpload', label: 'Employee Leave Availed', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'inputUploads/employeeAttendanceUpload', url: '/inputUploads/employeeAttendanceUpload', label: 'Employee Attendance', privilege: USER_PRIVILEGES.VIEW_LAW },
            // { id: 'inputUploads/employeeWageUpload', url: '/inputUploads/employeeWageUpload', label: 'Employee Wage', privilege: USER_PRIVILEGES.VIEW_LAW }

        ]
    },
    {
        id: 'performerClient/setupInput', url: '/performerClient/setupInput', icon: 'dashboardNew', label: 'Setup Input', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER,
        children: [
            { id: 'performerClient/setupInput/fieldMapping', url: '/performerClient/setupInput/fieldMapping', icon: 'dashboardNew', label: 'Field Mapping', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_FIELD_MAPPING },
            { id: 'performerClient/setupInput/holidayList', url: '/performerClient/setupInput/holidayList', icon: 'dashboardNew', label: 'Holiday List', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_HOLIDAY_LIST },
        ]
    },
    {
        id: 'performerClient/employee', url: '/performerClient/employeeMasterUpload', icon: 'InputUploadsIcon', label: 'Upload Data', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER,
        children: [
            { id: 'performerClient/employeeMasterUpload', url: '/performerClient/employeeMasterUpload', label: 'Employee Master', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER },
            { id: 'performerClient/employeeLeaveCreditUpload', url: '/performerClient/employeeLeaveCreditUpload', label: 'Employee Leave Credit', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER },
            { id: 'performerClient/employeeLeaveAvailedUpload', url: '/performerClient/employeeLeaveAvailedUpload', label: 'Employee Leave Availed', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER },
            { id: 'performerClient/employeeAttendanceUpload', url: '/performerClient/employeeAttendanceUpload', label: 'Employee Attendance', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER },
            { id: 'performerClient/employeeWageUpload', url: '/performerClient/employeeWageUpload', label: 'Employee Wage', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_EMPLOYEE_MASTER }
        ]
    },
    {
        id: 'performerClient/registersQueue', url: '/performerClient/registersQueue', icon: 'LicenseType', label: 'Register Generation', privilege: USER_PRIVILEGES.VIEW_PERFORMER_CLIENT_REGISTER_QUE
    },
    {
        id: 'userManagement', url: '/userManagement/roles', icon: 'usersManagement', label: 'User Management',
        children: [
            { id: 'userManagement/roles', url: '/userManagement/roles', label: 'Manage Roles', privilege: USER_PRIVILEGES.VIEW_ROLES },
            { id: 'userManagement/users', url: '/userManagement/users', label: 'Manage Users', privilege: USER_PRIVILEGES.VIEW_USERS },
            {
                id: "userManagement/location-vendor-mapping",
                url: "/userManagement/location-vendor-mapping",
                label: "Location Vendor Mapping",
                privilege: USER_PRIVILEGES.VIEW_VENDOR_MAPPINGS,
            },
            { id: 'userManagement/mapping', url: '/userManagement/mapping', label: 'Company Mapping', privilege: USER_PRIVILEGES.VIEW_COMPANY_MAPPINGS },
            {
                id: 'userManagement/userDepartment', url: '/userManagement/userDepartment',
                label: 'User Department Mapping', privilege: USER_PRIVILEGES.VIEW_DEPARTMENT_USER_MAPPING
            }
        ]
    },
    {
        id: 'email', url: '/templates/email', icon: 'email', label: 'Email & Notifications',
        children: [
            { id: 'templates/email', url: '/templates/email', label: 'Email Templates', privilege: USER_PRIVILEGES.VIEW_EMAIL_TEMPLATES },
            { id: 'templates/notification', url: '/templates/notification', label: 'Notification Templates', privilege: USER_PRIVILEGES.VIEW_NOTIFICATION_TEMPLATES }
        ]
    },
    // { id: 'activities', url: '/activities', icon: 'task', label: 'Activities', privilege: USER_PRIVILEGES.READ_ONLY_ACTIVITIES },
    { id: 'location-audits', url: '/location-audits', icon: 'notepad', label: 'Location Audits', privilege: USER_PRIVILEGES.REVIEWER_ACTIVITIES },
    // {
    // { id: 'activities', url: '/activities', icon: 'task', label: 'Activities', privilege: USER_PRIVILEGES.OWNER_ACTIVITIES },
    // { id: 'activities', url: '/activities', icon: 'task', label: 'Activities', privilege: USER_PRIVILEGES.MANAGER_ACTIVITIES },
    {
        id: 'location-audits',
        url: '/location-audits',
        icon: 'notepad',
        label: 'Location Audits',
        privilege: USER_PRIVILEGES.SUBMITTER_ACTIVITIES
    },

    // {
    //     id: "vendor-location-activities",
    //     url: "/vendor-location-activities",
    //     icon: "task",
    //     label: "Vendor Audits",
    //     privilege: USER_PRIVILEGES.SUBMITTER_VENDOR_ACTIVITIES,
    // },
    { id: 'notices', url: '/notices', icon: 'NoticesIcon', label: 'Notices', privilege: USER_PRIVILEGES.VIEW_NOTICES },
    { id: 'reports', url: '/reports', icon: 'report', label: 'Reports', disable: true },
    { id: 'notifications', url: '/notifications', icon: 'notification', label: 'Notifications', privilege: USER_PRIVILEGES.VIEW_USER_NOTIFICATIONS }
];

function SideNavNew({ open, toggleSidenav }: any) {
    const [user] = useState(auth.getUserDetails());
    const [sideMenu, setSideMenu] = useState<any[] | null>([]);
    const [hoveredItemId, setHoveredItemId] = useState<string | null>(null);
    const hoverTimerRef = useRef<any>(null);

    const location: any = window.location;
    useEffect(() => {

        if (location.pathname === '/location-audits') {
            //debugger;
            setTimeout(() => {
                const sideNavElement: any = document.querySelector('.sideNav a[href="/location-audits"]');
                const sideNavElementClass: any = sideNavElement.classList;
                sideNavElementClass.add('active');
            }, 200)
        }
    }, [location.pathname]);

    // Collapse all sub-menus whenever the sidenav closes
    useEffect(() => {
        if (!open) setHoveredItemId(null);
    }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (user) {
            const privileges: any = auth.getUserPrivileges();
            const _menu: any[] = [];
            SideNavMenu.forEach((menu: any) => {
                if (menu.children) {
                    const children = menu.children.filter((child: any) => {
                        return privileges.includes(child.privilege);
                    });
                    if (children.length) {
                        _menu.push({
                            ...menu,
                            children
                        });
                    }
                } else {
                    if (privileges.includes(menu.privilege)) {
                        _menu.push(menu);
                    }
                }
            });
            setSideMenu(_menu);
        }
    }, [user]);

    function NavItem({ children, url, name, hasChild, index, parentIndex }: any) {
        const [isActive, setActive] = useState(false);
        const urlPath = window.location.pathname;
        function onClick(e: any) {
            preventDefault(e);
            navigate(`${getBasePath()}${url}`, { replace: true });
        }

        useEffect(() => {
            if (urlPath) {
                setActive(urlPath.includes(name));
                const hasDashboardAccess = auth.hasUserAccess(USER_PRIVILEGES.OWNER_DASHBOARD)
                    || auth.hasUserAccess(USER_PRIVILEGES.MANAGER_DASHBOARD)
                    || auth.hasUserAccess(USER_PRIVILEGES.SUBMITTER_DASHBOARD)
                    || auth.hasUserAccess(USER_PRIVILEGES.REVIEWER_DASHBOARD)
                if (hasDashboardAccess && urlPath === '/' && parentIndex === 0 && (index === undefined || index === 0)) {
                    setActive(true);
                }
            }
        }, [urlPath]);

        return (
            <a href={url} onClick={onClick} className={isActive ? 'active' : ''}>
                {children}
            </a>
        )
    }

    function resetToggle() {
        clearTimeout(hoverTimerRef.current);
        setHoveredItemId(null);
    }

    return (
        <>
            {
                (user !== null && sideMenu !== null) ?
                    <ul className='sideNav m-0 p-0'>
                        <li>
                            <div className="d-flex flex-row w-100 align-items-center justify-content-end" style={{ height: '48px' }}>
                                <span className="sidenav-item-icon" style={{ cursor: 'pointer' }}>
                                    <Icon name={open ? 'double-left' : 'double-right'} action={() => {
                                        toggleSidenav(!open);
                                        resetToggle();
                                    }} className={"px-3 px-2"} />
                                </span>
                            </div>
                        </li>
                        {
                            sideMenu.map((item, index) => {
                                const hasChild = (item.children || []).length > 0;
                                return (
                                    <li
                                        key={item.id}
                                        className={hasChild && hoveredItemId === item.id ? 'dropdown-expanded' : ''}
                                        onMouseEnter={() => {
                                            if (hasChild) {
                                                clearTimeout(hoverTimerRef.current);
                                                hoverTimerRef.current = setTimeout(() => setHoveredItemId(item.id), 250);
                                            }
                                        }}
                                        onMouseLeave={() => {
                                            if (hasChild) {
                                                clearTimeout(hoverTimerRef.current);
                                                setHoveredItemId(null);
                                            }
                                        }}
                                    >
                                        <button type="button" disabled={item.disable}>
                                            <NavItem url={hasChild ? item.children[0].url : item.url} name={item.id} hasChild={hasChild} parentIndex={index} toggleSidenav={toggleSidenav} resetToggle={resetToggle}>
                                                <div className='d-flex flex-row align-items-center w-100'>
                                                    {
                                                        item.icon &&
                                                        <span className="sidenav-item-icon">
                                                            <Icon name={item.icon} />
                                                        </span>
                                                    }
                                                    <span className="sidenav-item-label">{item.label}</span>
                                                    {
                                                        hasChild &&
                                                        <Icon name={hoveredItemId === item.id ? 'angle-up' : 'angle-down'}
                                                            className={'ms-auto d-none'} />
                                                    }
                                                </div>
                                            </NavItem>
                                            {
                                                item.children &&
                                                <div className={`d-flex flex-column w-100 justify-content-start children ${hoveredItemId !== item.id ? 'd-none' : 'd-flex'}`}>
                                                    {
                                                        item.children.map((child: any, childIndex: number) => (
                                                            <NavItem url={child.url} key={child.id} name={child.id} index={childIndex} parentIndex={index} toggleSidenav={toggleSidenav} resetToggle={resetToggle}>
                                                                <span className="sidenav-item-label">{child.label}</span>
                                                            </NavItem>
                                                        ))
                                                    }
                                                </div>
                                            }
                                        </button>
                                    </li>
                                )
                            })
                        }
                    </ul> : null

            }
            <div className="d-flex justify-content-center align-items-center mt-5" style={{width: "50px", paddingBottom: "20px", paddingLeft: "10px"}}>
                <img src={mofoi_logo} width={'40px'} height={'40px'} alt='Mofoi Logo' />
            </div>
        </>
    );

}

export default SideNavNew;